//put all text constants here
const Constants = {
    APPNAME: "GreeNeighborhood",
    DIDYOUKNOW:
        "Did you know that pollution affects our quality of life even for us far up north ?",
    SOURCE:
        "Source:<<https://doi.org/10.1007/s11136-015-1104-6>>.", 
    SOURCE_DESCRIPTION:
        "As unfortunate contributors to the environmental degrade, let's observe the communities throughout the montreal metropolitain area that are doing their best in maintaining a healthy environment and try to follow in their footsteps as best we can.",
    HOMEPAGE_BUTTON: "Find out",
    HOME: "HOME",
    MAP: "MAP",
    WELCOME: "WELCOME, ",
    LOGOUT: "Log out",
    CHOOSE_DATA_TYPE : "PICK A DATASET TO VIEW ON THE MAP"
};
export default Constants;

